import { Navigate, Outlet, useParams } from "react-router-dom";

export function UuidGuard() {
  const { uuid } = useParams();

  if (!uuid) return <Navigate to="/" />;

  return <Outlet context={{ uuid: uuid }} />;
}
